import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import API from "../../api/api";

export default function AdminSidebar() {
  const { pathname } = useLocation();
  const [tournaments, setTournaments] = useState([]);
  const [selectedTournamentId, setSelectedTournamentId] = useState("");

  useEffect(() => {
  async function loadTournaments() {
    try {
      const res = await API.get("/tournaments/public/list"); // <-- fix endpoint
      const data = Array.isArray(res) ? res : [];
      setTournaments(data);

      if (data.length > 0 && !selectedTournamentId) {
        setSelectedTournamentId(data[0].id);
      }
    } catch (err) {
      console.error("Failed to load tournaments:", err);
    }
  }

  loadTournaments();
}, []);

  const link = (path, text) => (
    <Link
      to={path}
      className={`block py-3 px-5 rounded-lg mb-2 transition ${
        pathname === path ? "bg-yellow-600 text-black font-bold" : "bg-gray-800 hover:bg-gray-700"
      }`}
    >
      {text}
    </Link>
  );

const navigate = useNavigate();
const [events, setEvents] = useState([]);
const [selectedEventId, setSelectedEventId] = useState("");
const { eventId } = useParams();

useEffect(() => {
  if (eventId) {
    setSelectedEventId(eventId);
  }
}, [eventId]);

useEffect(() => {
  async function loadEvents() {
    try {
      const res = await API.get("/events");
      console.log("Raw Response:", res);

      // Try to find the array whether it's res, res.data, or res.data.events
      const rawData = res.data || res; 
      const actualEvents = Array.isArray(rawData) 
        ? rawData 
        : (Array.isArray(rawData.events) ? rawData.events : []);

      setEvents(actualEvents);

      if (actualEvents.length > 0 && !selectedEventId) {
        setSelectedEventId(actualEvents[0].id);
      }
    } catch (err) {
      console.error("Failed to load events:", err);
    }
  }
  loadEvents();
}, []);

  return (
    <div className="w-64 bg-gray-950 p-5 border-r border-gray-700">
      <h1 className="text-2xl font-bold text-yellow-500 mb-4">WAR FC Admin</h1>

      {link("/admin/dashboard", "Dashboard")}
      {selectedTournamentId && link(`/admin/tournaments/${selectedTournamentId}/fighters`, "Manage List")}
      {link("/admin/tournament/create", "Create Tournament")}

      <h2 className="text-yellow-400 mt-4 mb-2">Select Tournament</h2>
      {tournaments.length > 0 ? (
        <select
          className="p-2 mb-4 bg-gray-800 text-white rounded w-full"
          value={selectedTournamentId}
          onChange={(e) => setSelectedTournamentId(e.target.value)}
        >
          {tournaments.map((t) => (
            <option key={t.id} value={t.id}>
              {t.name}
            </option>
          ))}
        </select>
      ) : (
        <p className="text-gray-400 mb-4">No tournaments available</p>
      )}

<h2 className="text-yellow-400 mt-4 mb-2">Select Event</h2>
{events.length > 0 ? (
  <select
    className="p-2 mb-4 bg-gray-800 text-white rounded w-full"
    value={selectedEventId}
    onChange={(e) => {
  const eventId = e.target.value;
  setSelectedEventId(eventId);
  navigate(`/admin/events/${eventId}/fighters`);
}}

  >
    {events.map((e) => (
      <option key={e.id} value={e.id}>
        {e.name}
      </option>
    ))}
  </select>
) : (
  <p className="text-gray-400 mb-4">No events available</p>
)}

{selectedEventId && (
  <>
    {link(`/admin/events/${selectedEventId}/fighters`, "Manage Fighters")}
    {link(`/admin/events/${selectedEventId}/fightcard`, "Generate Fight Card")}
  </>
)}

      {/* Conditional links based on selected tournament */}
      {selectedTournamentId && (
        <>
          {link(`/admin/tournament/${selectedTournamentId}`, "Manage Tournament")}
          {link(`/admin/tournaments/${selectedTournamentId}/fighters`, "Tournament List")}
          {link(`/admin/tournament/${selectedTournamentId}/bracket`, "Tournament Bracket")}
        </>
      )}
    </div>
  );
}
